import { useState, useEffect } from 'react'
import { Table, Typography } from 'antd'
import { getGameAnomaly } from 'src/api/reports'
import { isoToTimestamp } from 'src/utils/timestamp'
const { Title, Text } = Typography

const GamesAnomaly = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [totalRecords, setTotalRecords] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const fetchCheater = async (page, size) => {
    setLoading(true)
    try {
      const res = await getGameAnomaly(page - 1, size)
      console.log('getGameAnomaly : ', res)
      const mapped = res.data.map((item) => ({
        key: item.userId,
        ...item,
      }))
      setTotalRecords(res.total_items)

      setData(mapped)
    } finally {
      setLoading(false)
    }
  }
  const formatEnumText = (text) => {
    if (!text) return ''

    return text
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  const columns = [
    {
      title: 'User Id',
      dataIndex: 'userId',
    },
    {
      title: 'Game Id',
      dataIndex: 'gameId',
    },
    {
      title: 'Country',
      dataIndex: 'country',
    },
    {
      title: 'Severity',
      dataIndex: 'severity',
      render: (text) => {
        return formatEnumText(text)
      },
    },
    {
      title: 'Actual Value',
      dataIndex: 'actualValue',
    },
    {
      title: 'Extreme Value',
      dataIndex: 'extremeValue',
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      render: (text) => {
        return isoToTimestamp(text)
      },
    },
  ]

  const handleTableChange = (pagination: any) => {
    setData([])
    setCurrentPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  useEffect(() => {
    fetchCheater(currentPage, pageSize)
  }, [currentPage, pageSize])

  return (
    <div>
      <Title level={4} style={{ color: '#fff' }}>
        Games Anomaly
      </Title>

      <Table
        style={{ marginTop: 20 }}
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          showSizeChanger: true,
          pageSizeOptions: ['10', '25', '50', '100'],
          total: totalRecords,
        }}
        onChange={handleTableChange}
      />
    </div>
  )
}
export default GamesAnomaly
